import { useMemo } from "react";
import { useSyncedResource } from "hooks/useSyncedResource.hook";
import * as SCOPE from "services/sync/scope";
import useInfrastructure from "hooks/useInfrastructure.hook";

export function useChatConversations({ enabled, lineId, userId, syncFn } = {}) {
  const { syncEngine, repositories } = useInfrastructure();
  const repository = repositories.conversations;
  
  enabled = enabled && !!lineId && !!userId;
  const scope = SCOPE.CHAT.CONVERSATIONS;
  const key = useMemo(() => `(lineId:${lineId})-(userId:${userId})`, [lineId, userId]);
  const syncParams = useMemo(() => ({ lineId, userId }), [lineId, userId]);

  return useSyncedResource({
    enabled,
    scope,
    key,
    cacheFn: ({ scope, key }) => repository.getFromCache(scope, key, () => repository.getByLineIdUserId(lineId, userId)),
    syncParams,
    syncFn,
    syncEngine,
    repository,
    repositories,
    deps: [lineId, userId]
  });
}